export const localStorageKeys = {
    recentlyViewed: 'vp_recently_viewed',
    quote: 'vp_quote',
    shortlist: 'vp_shortlist'
}



// WEBPACK FOOTER //
// /data/web/app/themes/epv/bs-embeds/src/config/localStorage.js